import React from 'react';
import {ContentTitle} from 'src/design/atoms/Typography';
import {AuditLogsDeepSearch} from 'src/app/audit-logs/AuditLogsDeepSearch/AuditLogsDeepSearch';

export const DeepSearchTab: React.FC = () => {
  return (
    <>
      <ContentTitle title="Deep Search" />
      <AuditLogsDeepSearch />
    </>
  );
};

export default DeepSearchTab;
